module.exports = {
    baseURL:"",
    api:{

    }
};
